import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import ReactSelect from "react-select";

// Components
import Form, { Group } from "~/common/components/Form";
import Input from "~/common/components/Input";
import DatePicker from "~/common/components/DatePicker";

// Assets
import { FilterIcon } from "~/assets/svg/InterfaceIcon";
import Radio from "~/common/components/Radio";
import { INVEST_LEVEL } from "~/constant/ApplyFormConstant";

const Filter = ({
	useForm,
	onSubmit,
	industryOptions,
	onChangeIndustry,
	onChangeComValue,
	onChangeInvest,
	roundToggle = true,
	setFormData,
	formData,
}) => {
	const { t } = useTranslation();
	const [min, setMin] = useState("");
	const [max, setMax] = useState("");
	const [isOpenDetail, setIsOpenDetail] = useState(false);
	const [comapanyValue, setCompanyValue] = useState(false);
	const [dateReadOnly, setDateReadOnly] = useState(true);

	const formDate = useForm.watch("dateType");
	const currentStartDate = useForm.watch("investStart");
	const currentEndDate = useForm.watch("investEnd");

	const dateTypeOptions = [
		{ label: "전체", value: "1" },
		{ label: "3개월", value: "2" },
		{ label: "6개월", value: "3" },
		{ label: "12개월", value: "4" },
		{ label: "직접입력", value: "5" },
	];

	const submit = (data) => {
		const submitData = {
			name: data.companyName,
		};

		onSubmit && onSubmit(submitData);
	};

	const handleChangeIndustry = (values) => {
		onChangeIndustry && onChangeIndustry(values.map((v) => v.value));
	};

	const handleSaveCompanyValue = () => {
		onChangeComValue(min, max);
	};

	const handleChangeInvest = (steps) => {
		onChangeInvest && onChangeInvest(steps.map((v) => v.value));
	};

	const clickDateType = (e) => {
		const selectedDate = e.target.value;

		if (formDate === selectedDate) {
			useForm.setValue("dateType", "");
		} else {
			let investStart = "";
			let investEnd = "";

			switch (selectedDate) {
				case "1":
					investStart = new Date(null);
					investEnd = new Date();
					setDateReadOnly(true);
					setFormData({ ...formData, investStart: "", investEnd: "" });
					break;
				case "2":
					investStart = new Date(new Date().setMonth(new Date().getMonth() - 3));
					investEnd = new Date();
					setDateReadOnly(true);
					setFormData({ ...formData, investStart: investStart, investEnd: investEnd });
					break;
				case "3":
					investStart = new Date(new Date().setMonth(new Date().getMonth() - 6));
					investEnd = new Date();
					setDateReadOnly(true);
					setFormData({ ...formData, investStart: investStart, investEnd: investEnd });
					break;
				case "4":
					investStart = new Date(new Date().setFullYear(new Date().getFullYear() - 1));
					investEnd = new Date();
					setDateReadOnly(true);
					setFormData({ ...formData, investStart: investStart, investEnd: investEnd });
					break;
				case "5":
					investStart = new Date();
					investEnd = new Date();
					setDateReadOnly(false);
					break;
				default:
					break;
			}

			useForm.setValue("investStart", investStart);
			useForm.setValue("investEnd", investEnd);
		}
	};

	const checkCompanyValue = () => {
		const minNumber = parseInt(min, 10);
		const maxNumber = parseInt(max, 10);

		if (minNumber > maxNumber) {
			setCompanyValue(true);
		} else {
			setCompanyValue(false);
		}
	};

	return (
		<>
			<Form useForm={useForm}>
				<Group
					label={t("pages.portfolio.PortfolioList.components.Filter.companyName")}
					className="company-search-wrap"
				>
					<Input
						name="companyName"
						placeholder={t("pages.portfolio.PortfolioList.components.Filter.inputName")}
						onEnter={useForm.handleSubmit(submit)}
					/>
					<button
						type="button"
						className="btn__solid angled btn-search"
						color="primary"
						onClick={useForm.handleSubmit(submit)}
					>
						{t("pages.portfolio.PortfolioList.components.Filter.search")}
					</button>
					<span className="divider" />
					<button
						type="button"
						className={`btn__outline angled btn-filter ${isOpenDetail ? "active" : ""}`}
						color="primary"
						onClick={() => setIsOpenDetail((prev) => !prev)}
					>
						<FilterIcon />
					</button>
				</Group>
			</Form>
			{isOpenDetail && (
				<div className="detail-wrap">
					<div className="f__group-row company-value">
						{/* 투자시점 */}
						<Form useForm={useForm}>
							{roundToggle && (
								<Group
									label={t(
										"pages.portfolio.PortfolioList.components.Filter.investPoint"
									)}
									className="datePicker-group"
								>
									<Radio
										name="dateType"
										options={dateTypeOptions}
										handleClick={clickDateType}
										className="c__switch"
									/>
									<DatePicker
										name="investStart"
										maxDate={currentEndDate}
										readonly={dateReadOnly}
										onChange={(date) => {
											setFormData({ ...formData, investStart: date });
										}}
										className={`invest-date`}
									/>
									<span className="dash"> - </span>
									<DatePicker
										name="investEnd"
										minDate={currentStartDate}
										readonly={dateReadOnly}
										onChange={(date) => {
											setFormData({ ...formData, investEnd: date });
										}}
										className={`invest-date`}
									/>
								</Group>
							)}
						</Form>
						{/* 기업가치 */}
						<div className="f__group invest-value">
							<div className="f__label">
								{t("pages.portfolio.PortfolioList.components.Filter.companyValue")}
							</div>
							<div className={`f__control ${comapanyValue ? "has-error" : ""}`}>
								<input
									type="number"
									className="c__input"
									placeholder={t("pages.round.RoundReg.components.Filter.unit")}
									onChange={(e) => setMin(e.target.value)}
									value={min}
								/>
								<div className="divider" />
								<input
									type="number"
									className="c__input"
									placeholder={t("pages.round.RoundReg.components.Filter.unit")}
									onChange={(e) => setMax(e.target.value)}
									value={max}
								/>
								<button
									type="button"
									className="btn__solid angled btn-detail"
									color="primary"
									onClick={() => {
										handleSaveCompanyValue();
										checkCompanyValue();
									}}
								>
									{t("common.commonWord.button.apply")}
								</button>
								{comapanyValue && (
									<div className="f__feedback">
										최소 금액이 최대 금액보다 클 수 없습니다.
									</div>
								)}
							</div>
						</div>
					</div>
					<div className="f__group-row">
						{/* 산업분야 */}
						<div className="f__group industry-category">
							<div className="f__label">
								{t("pages.portfolio.PortfolioList.components.Filter.industryFiled")}
							</div>
							<div className="f__control">
								<ReactSelect
									closeMenuOnSelect={false}
									onChange={handleChangeIndustry}
									options={industryOptions}
									placeholder="산업분야를 선택해주세요."
									className="basic-multi-select"
									classNamePrefix="react-select"
									isMulti
								/>
							</div>
						</div>
						{/* 투자단계 */}
						<div className="f__group invest-step">
							<div className="f__label">투자단계</div>
							<div className="f__control">
								<ReactSelect
									closeMenuOnSelect={false}
									onChange={handleChangeInvest}
									options={INVEST_LEVEL}
									placeholder="투자단계를 선택해주세요."
									className="basic-multi-select"
									classNamePrefix="react-select"
									isMulti
								/>
							</div>
						</div>
					</div>
				</div>
			)}
		</>
	);
};

export default Filter;
